import HttpClient from '../../utils/HttpClient';

const httpClient = HttpClient.createInstance();

export const requestVerification = (phoneNumber, channel) =>
  httpClient.post('/verify/request', { phoneNumber, channel });

export const checkVerification = (code, phoneNumber) =>
  httpClient.post('/verify/check', { code, phoneNumber });
